const $masonry = $('.masonry');

if ($masonry.length) {
    require(['imagesloaded', 'masonry-layout'], (imagesLoaded, Masonry) => {
        // loop over all our masonry blocks and init them
        $masonry.each(function (i, container) {
            imagesLoaded(container, () => {
                new Masonry(container, {
                    columnWidth: '.masonry__sizer',
                    itemSelector: '.masonry__item',
                    percentPosition: true,
                });
            });
        });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/layouts/masonry.js